module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/addeditadminlist/addeditadminlist.component.css
// module id = ./src/app/addeditadminlist/addeditadminlist.component.css
// module chunks = main